import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";
import MenuIndex from "./Components/MenuIndex";

const MLSIndex = () => {
    return ( 
        <>
         <CountinueOnMobileApp
    isShowChildren={false}
    isShowDesc
    desc="PPS Portföy Paylaşım Sistem sekmeleri yalnızca web sürümümüzde görüntülenebilir"
  useInWeb={true}
  noDataSrc="https://cdn-icons-png.flaticon.com/512/6801/6801736.png"
  >


        <MenuIndex/>
  </CountinueOnMobileApp>
        </>
     );
}
 
export default MLSIndex;